window.PXUTheme.jsAnnouncementBar = {
  init: function($section){
    // Add settings from schema to current object
    window.PXUTheme.jsAnnouncementBar = $.extend(this, window.PXUTheme.getSectionData($section));

    // Get announcement bar element
    let template = this.homepage_only ? '.index' : '';
    this.$el = $('#announcement-bar', template);
    
    // Get announcement bar cookie state
    let announcementCookie = Cookies.get('announcement-bar');
    
    // Use the predefined height - prevents recalculation layout shifts
    //this.announcementHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-height')) || 0;
    
    if (this.show_close_icon === false) {
      // Close icon is disabled, always show announcement
      Cookies.remove('announcement-bar');
      this.show();
    } else if (announcementCookie !== 'dismiss') {
      // Close icon has not been clicked
      this.show();
    } else {
      // Close icon has been clicked and announcement is hidden
      // Initial state is already set via inline script, just ensure JS state matches
      $('body').addClass('announcement-bar--hidden');
      this.disableSticky();
      return false;
    }

    // Sticky announcement bar
    if (this.enable_sticky === true) {
      this.enableSticky();
    } else {
      this.disableSticky();
    }

    // Handle close icon click events
    if (this.show_close_icon === true) {
      $('body').addClass('has-announcement-bar-toggle');
      
      // Attach event to hide announcement if close icon is clicked
      this.$el.on('click', '.js-close-announcement', () => {
        this.hide();
      });
    }
  },
  show: function() {
    $('body')
      .addClass('announcement-bar--visible')
      .removeClass('announcement-bar--hidden')
      .removeClass('announcement-bar--hidden-initial')
      .css({
        'display': 'flex',
        'flex-wrap': 'wrap'
      });
  },
  enableSticky: function() {
    // Add sticky functionality and recalculate offset for header sticky
    this.$el.parent().sticky({
      wrapperClassName: 'announcement-sticky-wrapper',
      topSpacing: 0
    });

    this.resetHeader(this.announcementHeight);
  },
  disableSticky: function() {
    // Remove sticky functionality and recalculate offset for header sticky
    this.$el.parent().unstick();
    this.resetHeader(0);
  },
  hide: function() {
    // Remove announcement bar and set cookie to hide it for 30 days
    $('body')
      .removeClass('announcement-bar--visible')
      .removeClass('announcement-bar--visible-initial')
      .addClass('announcement-bar--hidden');
      
    this.disableSticky();
    Cookies.set('announcement-bar', 'dismiss', { expires: 30 });
  },
  resetHeader: function(offset) {
    if (!window.PXUTheme.jsHeader) return;

    if (window.PXUTheme.jsHeader.enable_sticky === true && isScreenSizeLarge()) {
      if (window.PXUTheme.theme_settings.header_layout != 'vertical') {
        // Reset desktop sticky header
        window.PXUTheme.jsHeader.disableSticky();
        window.PXUTheme.jsHeader.enableSticky(offset);
      }
    } else if (window.PXUTheme.jsHeader.enable_sticky === true && !isScreenSizeLarge()) {
      // Reset mobile sticky header
      window.PXUTheme.mobileMenu.disableSticky();
      window.PXUTheme.mobileMenu.enableSticky(offset);
    }
  },
  getAnnouncementHeight() {
    return this.announcementHeight;
  },
  unload: function($section) {
    // Clear event listeners in theme editor
    $('#announcement-bar').off();
    $('#announcement-bar').unstick();
  }
}